export default "__VITE_ASSET__CZ3Kf7_Y__"